// ----------------------------------------------------------------------------
// Snippet: Country Modal
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
// Scripts
import $ from 'jquery';
import '../../snippets/_containers/modal/modal';

// Styles
import './_country-modal.scss';

/**
 * Country Modal Snippet Script
 * ------------------------------------------------------------------------------
 * A file that manage the country popup switcher when the user first comes to the website.
 * There will be no popup for returning users.
 */

var inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

// Country Switch Popup
var doLocale = function() {

    var countryMap = {
        'mustang-survival-development.myshopify.com':   'FK,IM,JE,GB',
        'mustang-survival-uk.myshopify.com':            'FK,IM,JE,GB',
        'mustang-survival.co.uk':                       'FK,IM,JE,GB',
        'mustang-survival-ca.myshopify.com':            'CA',
        'mustangsurvival.ca':                           'CA',
        'mustang-survival.myshopify.com':               'US',
        'mustangsurvival.com':                          'US',
        'pro.mustangsurvival.com':                      'MPS'
    };


    var hostCountry = countryMap[document.domain];

    if (hostCountry != "MPS") {

        // Default to US
        if (hostCountry === undefined) {
            var hostCountry = 'US';
        }else {
            var hostCountry = hostCountry.split(',');
        }
        // Set CSS class on body
        //$('body').addClass('country--'+hostCountry.toLowerCase());

        // Don't show the modal if If we are inside the customizer.
        if (inIframe()) { return; }

        /**
         * Return Visitor!
         */
        if (localStorage.getItem('userCountry') !== null) {

            // if (localStorage.getItem('userCountry') != hostCountry) {

            //     $('#country-modal').addClass('js--isOpen');
            // }
        }

        /**
        * Show the modal if GeoIP2 fails to load or is blocked for security
        */
        else if (typeof geoip2 === 'undefined') {
            $('#country-modal').addClass('modal--open');
        }

        /**
         * Newbie user!
         */
        else {
            //GeoIP fetched successfully
            var geoSuccess = function(location) {
                var geoCountryCode = location.country.iso_code;
                var geoSubdivision = location.subdivisions[0].iso_code;

                // assign country to localStorage.
                localStorage.setItem('geoCountry', geoCountryCode);
                if (geoSubdivision) {
                    localStorage.setItem('geoSubdivision', geoSubdivision);
                }

                // CHECK! Does geo country match host country?
                if ( hostCountry.includes(geoCountryCode) !== true ) {

                    $('#country-modal').addClass('modal--open');
                }
            };
            // GeoIP Failed, show popup always
            var geoError = function(err) {

                // Show modal if we cannot detect country.
                $('#country-modal').addClass('modal--open');
                // console.log(err);
            };

            // Get location from geoip database
            geoip2.city(geoSuccess, geoError);
        }
    }

    $('#country-modal .country-popup__item, #country-modal .country-popup__button, #country-modal .modal__overlay').on('click', function(e){
        e.preventDefault();

        var linkCountry = $(this).attr('data-country');
        localStorage.setItem('userCountry', linkCountry);

        console.log(linkCountry);
        console.log(hostCountry);
        console.log(hostCountry.includes(linkCountry));


        if ( hostCountry.includes(linkCountry) === true) {
            $('#country-modal').removeClass('modal--open');
        } else {
            window.location = $(this).attr('href');
        }

    });

    $('#country-modal .modal__overlay').on('click', function(e){
        console.log("clickkkk");
        e.preventDefault();
    });
};

doLocale();
